import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// UI Components
import { Card, Col, Container, Row } from "react-bootstrap";
import EnvHeader from "../components/Env/Env.Header";
import EnvVersionFooter from "../components/Env/Env.Version.Footer";

interface AuthOptions {
  children: any;
  account_error?: string;
}

const SimpleLayout: any = ({ children, account_error }: AuthOptions) => {
  if (account_error) {
    return (
      <Container data-testid="sign-in">
        <Row className="justify-content-md-center align-items-center" style={{ height: "95vh" }}>
          <Col md={8} xl={6}>
            <Card className="text-center">
              <Card.Body>Account Error</Card.Body>

              <Card.Body className="text-muted">
                <Card.Text>
                  There was an error retrieving your account information.
                  <br />
                  Please contact customer service!
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <React.Fragment>
      <EnvHeader />

      {children}

      <EnvVersionFooter />
    </React.Fragment>
  );
};

const mapStateToProps = (state: any) => ({
  account_error: state.account.error,
});

SimpleLayout.propTypes = {
  account_error: PropTypes.string,
};

export default connect(mapStateToProps)(SimpleLayout);
